/**
 * Root reducer - combines all feature slices
 */

import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import uiReducer from './features/ui/uiSlice';
import preferencesReducer from './features/preferences/preferencesSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  preferences: preferencesReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
